import { enhancedApi } from './generated/documentSubjectService';

export const {
  useSubjectDocumentsListQuery,
  useSubjectDocumentsCreateMutation,
  useSubjectDocumentsDownloadQuery,
  useSubjectDocumentsPreviewQuery,
  useSubjectDocumentsRefreshMutation,
  useLazySubjectDocumentsListQuery,
  useSubjectDocumentsResendMutation,
  useSubjectDocumentsSendMutation,
} = enhancedApi;
